module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_9016.6fa11de0.png";